import main_logo from '../components/asset/images/astronX-logo.png'
import apod_background from '../components/asset/images/apod_background.jpg'
import mars from '../components/asset/images/mars.png'
import earth from '../components/asset/images/earth.png'

export const LOGO = main_logo;
export const MARS_IMAGE = mars;
export const EARTH_IMAGE = earth;
export const USER_AVATAR = 'https://aui.atlassian.com/aui/8.7/docs/images/avatar-person.svg';
export const APOD_CARD_IMAGE = 'https://images.pexels.com/photos/1025469/pexels-photo-1025469.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1';
export const EMRI_CARD_IMAGE = 'https://static.scientificamerican.com/sciam/cache/file/147F0066-DE0F-4F8F-BD377DBC9B172E20_source.png?w=600';
export const TES_CARD_IMAGE = 'https://images.pexels.com/photos/76969/cold-front-warm-front-hurricane-felix-76969.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1';
export const NASA_LOGO = 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/NASA_logo.svg/2449px-NASA_logo.svg.png';
export const APOD_PAGE_BACKGROUND = apod_background;


